import { definePlatformSetting } from '@crest/platform-contracts/settings';
import { z } from 'zod';
// Relationships owns these labels; the shared Platform setting system resolves tenant overrides.
export const relationshipsContactDetailCopySchema = z.strictObject({
    backAction: z.string().trim().min(1).max(240),
    loadingLabel: z.string().trim().min(1).max(240),
    loadError: z.string().trim().min(1).max(240),
    retryAction: z.string().trim().min(1).max(240),
    deniedLabel: z.string().trim().min(1).max(240),
    privateHiddenLabel: z.string().trim().min(1).max(240),
    organizationLabel: z.string().trim().min(1).max(240),
    typeLabel: z.string().trim().min(1).max(240),
    statusLabel: z.string().trim().min(1).max(240),
    phoneLabel: z.string().trim().min(1).max(240),
    emailLabel: z.string().trim().min(1).max(240),
    notesTitle: z.string().trim().min(1).max(240),
    emptyNotesLabel: z.string().trim().min(1).max(240),
    notesLoadingLabel: z.string().trim().min(1).max(240),
    notesError: z.string().trim().min(1).max(240),
    notesDeniedLabel: z.string().trim().min(1).max(240),
    addNoteAction: z.string().trim().min(1).max(240),
    bodyLabel: z.string().trim().min(1).max(240),
    noteTypeLabel: z.string().trim().min(1).max(240),
    pinnedLabel: z.string().trim().min(1).max(240),
    saveAction: z.string().trim().min(1).max(240),
    savingLabel: z.string().trim().min(1).max(240),
    cancelAction: z.string().trim().min(1).max(240),
    invalidNoteLabel: z.string().trim().min(1).max(240),
    saveError: z.string().trim().min(1).max(240),
    savedLabel: z.string().trim().min(1).max(240),
    refreshAction: z.string().trim().min(1).max(240),
    previousAction: z.string().trim().min(1).max(240),
    nextAction: z.string().trim().min(1).max(240),
    generalLabel: z.string().trim().min(1).max(240),
    callLabel: z.string().trim().min(1).max(240),
    siteVisitLabel: z.string().trim().min(1).max(240),
    internalLabel: z.string().trim().min(1).max(240),
    aiGeneratedLabel: z.string().trim().min(1).max(240),
    statusUpdateLabel: z.string().trim().min(1).max(240),
});
export const relationshipsContactDetailCopySetting = definePlatformSetting({
    definition: {
        key: 'relationships.copy.contact-detail', moduleId: 'relationships',
        title: 'Contact detail interface copy',
        helpText: 'Labels for contact summaries and the contact note history and composer.',
        configurationDomain: 'copy', valueType: 'object', schemaVersion: 1,
        codedFallback: {
            "backAction": "Back to contacts",
            "loadingLabel": "Loading contact…",
            "loadError": "This contact could not be loaded.",
            "retryAction": "Retry",
            "deniedLabel": "You do not have access to this contact.",
            "privateHiddenLabel": "Private phone and email details are hidden for your role.",
            "organizationLabel": "Organization",
            "typeLabel": "Type",
            "statusLabel": "Status",
            "phoneLabel": "Phone",
            "emailLabel": "Email",
            "notesTitle": "Contact notes",
            "emptyNotesLabel": "No contact notes yet.",
            "notesLoadingLabel": "Loading contact notes…",
            "notesError": "The contact notes could not be loaded.",
            "notesDeniedLabel": "You do not have permission to read contact notes.",
            "addNoteAction": "Add note",
            "bodyLabel": "Note",
            "noteTypeLabel": "Note type",
            "pinnedLabel": "Pinned",
            "saveAction": "Save note",
            "savingLabel": "Saving…",
            "cancelAction": "Cancel",
            "invalidNoteLabel": "Enter a note of 1–10,000 characters.",
            "saveError": "The save could not be confirmed. Keep this draft and check the contact history before trying again.",
            "savedLabel": "Note saved.",
            "refreshAction": "Refresh notes",
            "previousAction": "Previous notes",
            "nextAction": "Next notes",
            "generalLabel": "General",
            "callLabel": "Call",
            "siteVisitLabel": "Site visit",
            "internalLabel": "Internal",
            "aiGeneratedLabel": "AI generated",
            "statusUpdateLabel": "Status update"
        },
        permittedScopes: ['platform', 'plan', 'tenant'], mergeStrategy: 'deep-merge',
        clientSafe: true, serverOnly: false, sensitive: false, tenantEditable: true,
        userOverridable: false, offlineEligible: true, safetyClass: 'ordinary',
    },
    valueSchema: relationshipsContactDetailCopySchema,
});
//# sourceMappingURL=relationships-contact-detail-copy.js.map